export default {
  submitLoading: false,
  awsAccountList: [],
  newManagedServices: {
    registrationStep: 'listing', // ie, listing, validation, onboarding, contact
    sfdcId: '',
    searching: false,
    searchMessage: '',
    searchError: false,
    selected: false,
    opportunityName: '',
    workloadTitle: '',
    submittedDate: '',
    oppregStatus: '',
    // savingContact: false,
    // accountRecord: {},
    // noDiscount: false
  },
  managedServicesList: {
    registrationStep: 'listing', // ie, listing, validation, onboarding, contact
    listType: 'ManagedServices',
    selectedWorkload: [],
    loadingWorkloads: false,
    listWorkloadHeaders: [
      {
        sortable: true,
        text: 'Actions',
        value: ''
      },
      {
        sortable: true,
        text: 'Workload Title',
        value: 'Workload_Title'
      },
      {
        sortable: true,
        text: 'OppReg Req Date',
        value: 'OppReg_Req_Date'
      },
      {
        sortable: true,
        text: 'Workload Status',
        value: 'Workload_Status'
      },
      {
        sortable: true,
        text: 'Workload Type',
        value: 'Workload_type'
      }
    ],
    listHeaders: [
      {
        sortable: true,
        text: 'Actions',
        value: ''
      },
      {
        sortable: true,
        text: 'Opportunity Id',
        value: 'Opportunity_Id'
      },
      {
        sortable: true,
        text: 'AWS Accounts',
        value: 'AWS_Accounts'
      },
      {
        sortable: true,
        text: 'Description',
        value: 'Description'
      },
      {
        sortable: true,
        text: 'Status',
        value: 'Status'
      }
    ],
    listManagedServices: [],
    loadingList:false,
    workloads: [],
    setNextPageKey: '',
    regions: [
      {
        label: 'us-east-1 (N. Virginia)',
        value: 'us-east-1'
      },
      {
        label: 'us-east-2 (Ohio)',
        value: 'us-east-2'
      },
      {
        label: 'us-west-1 (N. California)',
        value: 'us-west-1'
      },
      {
        label: 'us-west-2 (Oregon)',
        value: 'us-west-2'
      },
      {
        label: 'us-gov-west-1 (US GovCloud West)',
        value: 'us-gov-west-1'
      },
      {
        label: 'us-gov-east-1 (US GovCloud East)',
        value: 'us-gove-east-1'
      },
      {
        label: 'ca-central-1 (Canada)',
        value: 'ca-central-1'
      },
      {
        label: 'eu-north-1 (Stockholm)',
        value: 'eu-north-1'
      },
      {
        label: 'eu-west-1 (Ireland)',
        value: 'eu-west-1'
      },
      {
        label: 'eu-west-2 (London)',
        value: 'eu-west-2'
      },
      {
        label: 'eu-west-3 (Paris)',
        value: 'eu-west-3'
      },
      {
        label: 'eu-central-1 (Frankfurt)',
        value: 'eu-central-1'
      },
      {
        label: 'eu-south-1 (Milan)',
        value: 'eu-south-1'
      },
      {
        label: 'af-south-1 (Cape Town)',
        value: 'af-south-1'
      },
      {
        label: 'ap-northeast-1 (Tokyo)',
        value: 'ap-northeast-1'
      },
      {
        label: 'ap-northeast-2 (Seoul)',
        value: 'ap-northeast-2'
      },
      {
        label: 'ap-northeast-3 (Osaka)',
        value: 'ap-northeast-3'
      },
      {
        label: 'ap-southeast-1 (Singapore)',
        value: 'ap-southeast-1'
      },
      {
        label: 'ap-southeast-2 (Sydney)',
        value: 'ap-southeast-2'
      },
      {
        label: 'ap-east-1 (Hong Kong)',
        value: 'ap-east-1'
      },
      {
        label: 'ap-south-1 (Mumbai)',
        value: 'ap-south-1'
      },
      {
        label: 'me-south-1 (Bahrain)',
        value: 'me-south-1'
      },
      {
        label: 'sa-east-1 (São Paulo)',
        value: 'sa-east-1'
      },
      {
        label: 'cn-north-1 (Bejing)',
        value: 'cn-north-1'
      },
      {
        label: 'cn-northwest-1 (Ningxia)',
        value: 'cn-northwest-1'
      },
      {
        label: 'ap-southeast-3 (Jakarta)',
        value: 'ap-southeast-3'
      }
    ]
  },
  awsAccountValidation: {
    wbsCode: null,
    wbsValidating: false,
    wbsValidationMessage: '',
    wbsCodeValidated: false,
    wbsType: null,
    iwoCode: null,
    iwoValidating: false,
    iwoValidationMessage: '',
    iwoCodeValidated: false,
    agreed: false,
    submitting: false,
    savingForLater: false,
    savedForLater: false,
    isPromoCode: null,
    awsCredits: null
  },
  updateManagedServices: {
    showDialog: false,
    data: {}
  }
}
